<template>
  <main>
    <v-card-title class="dialog-header ">{{ formTitle }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent="$emit('on_submit_form')">
        <form-wrapper :validator="v.form">
          <v-container>
            <v-row>
              <v-col cols="12" v-if="isEdit">
                <locale-select @change="$emit('change_locale', $event)" />
              </v-col>
              <v-col cols="12">
                <form-group name="name">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.name"
                      outlined
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <form-group name="value_type" attribute="label.value_type">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="items"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.value_type"
                      outlined
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <transition name="fade" mode="out-in">
                <v-col cols="12" v-if="form.value_type === 1">
                  <form-group
                    name="default_value"
                    attribute="label.default_value"
                  >
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="form.default_value"
                        outlined
                      ></v-text-field>
                    </template>
                  </form-group>
                </v-col>
              </transition>
              <transition name="fade" mode="out-in">
                <v-col cols="12" v-if="form.value_type === 2">
                  <form-group
                    name="default_value"
                    attribute="label.default_value"
                  >
                    <template slot-scope="{ attrs, listeners }">
                      <v-switch
                        false-value="'0'"
                        true-value="'1'"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="form.default_value"
                      >
                      </v-switch>
                    </template>
                  </form-group>
                </v-col>
              </transition>

              <v-col cols="12">
                <v-btn
                  class="primary"
                  type="submit"
                  :loading="loading"
                  :disabled="v.form.$invalid"
                  block
                  >{{ $t("button.submit") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </form-wrapper>
      </v-form>
    </v-card-text>
  </main>
</template>
<script>
export default {
  name: "FormActions",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default: () => {},
    },

    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [{ text: 1, value: 1 }, { text: 2, value: 2 }],
    };
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
  },
};
</script>
